module.exports = __webpack_public_path__ + "static/media/myinbrace-logo-gradient-transition.f5bcf33b.svg";